import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { hc } from 'hono/client';
import { AppType } from '../../../packages/functions/src/gems/api/public';

interface VideoViewerProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  theme: any;
  contactUrl: {
    userId: string;
    contactId: string;
  };
  gem: any;
  gemEndpoint: string;
}

const VideoViewer: React.FC<VideoViewerProps> = ({
  isOpen,
  onClose,
  url,
  theme,
  gem,
  contactUrl,
  gemEndpoint
}) => {
  useEffect(() => {
    if (isOpen && contactUrl) {
      const postActivity = async () => {
        const client = hc<AppType>(gemEndpoint, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        try {
          client.public.activity
            .$post({
              json: {
                userId: contactUrl.userId,
                gemId: gem.gemId,
                gemName: gem.name,
                activityType: 'play',
                contactId: contactUrl.contactId
              }
            })
            .catch((error) => {
              console.error('Failed to post activity:', error);
            });
        } catch (error) {
          console.error('Failed to initiate activity post:', error);
        }
      };
      postActivity();
    }
  }, [isOpen, contactUrl, gem, gemEndpoint]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center"
        style={{
          backgroundColor: theme?.layout?.background?.solid || theme.backgroundColor,
          zIndex: 9999
        }}
      >
        <iframe src={url} width="100%" height="100%" allowFullScreen />
        <button
          className="absolute top-2 right-2 bg-white border-none rounded-full w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={onClose}
        >
          x
        </button>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};

export default VideoViewer;
